<script lang="ts" setup>
import { defineAsyncComponent } from 'vue'
import type { GameItem } from '~composables/lobby-games/interface'
import { useLighthouse } from '~/composables/common/use-lighthouse'

const LoadingSpin = defineAsyncComponent(async () => await import('~common/loading-spin.vue'))
const GameItemComponent = defineAsyncComponent(
  async () => await import('~/components/common/lobby-games/game-item.vue')
)
const LoadMoreButton = defineAsyncComponent(
  async () => await import('~/components/desktop/pages/common/load-more-button.vue')
)

const { isLighthouseBot } = useLighthouse()

defineProps({
  lobbyGames: {
    type: Array<GameItem>,
    default: []
  },
  totalPost: {
    type: Number,
    default: 0
  },
  isLoadingGame: {
    type: Boolean,
    default: false
  },
  hideLoadMoreButton: {
    type: Boolean,
    default: false
  },
  hideGameName: {
    type: Boolean,
    default: false
  },
  keywordSearch: {
    type: String,
    default: ''
  }
})

const emits = defineEmits(['loadMore'])
</script>

<template>
  <div class="direct-games">
    <template v-if="!isLighthouseBot">
      <LoadingSpin v-if="isLoadingGame" />

      <div v-if="lobbyGames.length" class="lobby-games__list row row-12px">
        <div v-for="item in lobbyGames" :key="item.ID" class="col-4">
          <GameItemComponent :item="item" :hideGameName="hideGameName" isMobile />
        </div>
      </div>

      <LoadMoreButton
        v-if="!hideLoadMoreButton"
        :limit="lobbyGames.length"
        :total="totalPost"
        class="load-more"
        @loadMore="emits('loadMore')"
      />

      <div v-if="!lobbyGames?.length && !isLoadingGame" class="lobby-games__nodata">
        <img
          src="/assets/images/components/lobby-games/game-nodata.png"
          alt="Game nodata"
          fetchpriority="high"
          loading="eager"
          preload
        />
        <div class="lobby-games__nodata--content">
          <div class="desc">
            <template v-if="keywordSearch"> Không tìm thấy kết quả nào phù hợp! </template>
            <template v-else> Danh sách game đang được cập nhật </template>
          </div>
        </div>
      </div>
    </template>

    <template v-if="isLighthouseBot">
      <div class="lobby-games__nodata">
        <img
          src="/assets/images/components/lobby-games/game-nodata.png"
          alt="Game nodata"
          fetchpriority="high"
          loading="eager"
          preload
        />
        <div class="lobby-games__nodata--content">
          <div class="desc">Danh sách game đang được cập nhật</div>
        </div>
      </div>
      >
    </template>
  </div>
</template>

<style scoped lang="scss">
@import '~scssAsset/mobile/pages/lobby-games/direct-games.scss';
</style>
